module.exports = __webpack_public_path__ + "img/202.problem_broken_niagara.9c740a12.svg";